<template>
  <v-card
    color="transparent"
    data-aos="fade"
    flat
  >
    <v-container>
      <v-row class="d-flex flex-wrap-reverse" justify="space-around">
        <v-col xs="12" sm="5" class="mb-5 order-xs-2 order-sm-1 text-center">
          <v-img :src="img" class="elevation-2" height="600px"></v-img>
          <v-container fluid style="padding:0" class="mb-2">
            <v-row no-gutters>
              <v-col
                class="pa-1 thumbnail"
                cols="6"
                v-for="thumbnail in thumbnails"
                :key="thumbnail.index"
              >
                <v-img
                  style="cursor: pointer"
                  :src="thumbnail.src"
                  height="150px"
                  @click="onClick(thumbnail)"
                ></v-img>
              </v-col>
            </v-row>
          </v-container>
          <v-btn
            large
            color="primary"
            depressed
            squared
            :href="formLink"
            target="_blank">BOOKING FORM
          </v-btn>
        </v-col>
        <v-col xs="12" sm="6" class="order-xs-1 order-sm-2">
          <h1 class="pt-2">The Magic of Fermentation</h1>
          <v-row class="pricing-details" justify="space-between">
            <v-col class="text-center">
              3 HOUR PRIVATE WORKSHOP
            </v-col>
          </v-row>
          <p >
            Fermenting vegetables is an old way of preserving them thanks to naturally occurring bacteria. More than
            a preserving process, it is incredibly delicious and nourishing. The benefits of this process are both
            culinary, creating an umami flavour as well as nutritionally: consuming fermented products contributes
            to gut health.
          </p>

          <p>
            The workshop will start with a taster of sourdough breads and a selection of fermented products to excite
            the tastebuds! Then you will be making your own ferments: a traditional Korean kimchi and an amazing
            variety of fermented foods and drinks which you will keep and see ferment overtime (we provide the glass
            jars and containers). We will be discussing about gut health and why eating and drinking fermented foods
            contribute to our overall wellbeing.
          </p>

          <p>I am very excited to share this workshop with you, as it is a simple yet very efficient way of adding
            some fermented foods in your diet and understanding the reasons why they are so good.</p>

          <p>
            <b>Dates and Times</b> <br/>
            Availabilities throughout the week and weekend - please specify your preferred dates in the form.
          </p>
          <p>
            <b>Location</b> <br/>
            My kitchen in Hertford or yours.
          </p>
          <p>
            <b>Investment*</b> <br/>
            £175 for 2 persons from the same household. We offer discounts for a single person class,
            please <contact-link subject="The Magic Of Fermentation"></contact-link>.<br/>
          </p>
          <p>
            If you would like to get a small group together, please enquire in the booking form.
            *Further travel charges may apply.
          </p>
          <p class="subtext">
            I realise a lot of us may currently be in a difficult financial
            position. If this is your case, please email us to discuss
            discounted rates. I strongly believe in the mental and physical
            benefits of making our own food and that everybody should
            have access to learning how to take care of oneself.
          </p>
        </v-col>
      </v-row>
      <v-row
        v-bind="binding"
        align="stretch"
        justify="center"
        class="fill-height my-5 you-will text-center">
        <v-col
          class="learn"
          :class="borderClass"
          cols="12"
          sm="4"
        >
          <h3>You will learn</h3>
          <p>
            <ul>
              <li>What is lactic acid fermentation</li>
              <li>Culinary Benefits</li>
              <li>Health Benefits</li>
              <li>Creative and delicious ways of adding ferments as part of your daily life</li>
            </ul>
          </p>
        </v-col>
        <v-col
          class="make"
          :class="borderClass"
          cols="12"
          sm="4"
        >
          <h3>You will make*</h3>
          <v-row align="stretch" justify="center" class="fill-height">
            <v-row align="start" justify="center" no-gutters>
              <ul>
                <li>Our favourite kimchi</li>
                <li>Fermented carrot and ginger</li>
                <li>Seasonal brine ferment</li>
                <li>Seasonal kvass</li>
              </ul>
            </v-row>
            <v-row align="start" class="pa-3" justify="center" no-gutters>
              <p class="small-print">
                *May be subject to change. All the ingredients used are organically grown and
                local as much as possible.
              </p>
            </v-row>
          </v-row>
        </v-col>
        <v-col
          class="keep"
          :class="borderClass"
          cols="12"
          sm="4"
        >
          <h3>You will keep</h3>
          <p>
            <ul>
              <li>Your own ferments in glass jars</li>
              <li>A fermentation manual with everything you need to continue fermenting at home</li>
            </ul>
          </p>
        </v-col>
      </v-row>
    </v-container>
    <testimonials :filter="title"></testimonials>
  </v-card>
</template>

<script>
import {
  VBtn,
  VCard,
  VCol,
  VContainer,
  VImg,
  VRow,
} from 'vuetify/lib'
import ContactLink from '@/components/ContactLink'
import MetaInfoBuilder from '@/utils/social'
import Testimonials from '@/components/Testimonials'

export default {
  components: {
    ContactLink,
    Testimonials,
    VBtn,
    VCard,
    VCol,
    VContainer,
    VImg,
    VRow,
  },
  computed: {
    binding() {
      const binding = {}
      if (this.$vuetify.breakpoint.xsOnly) {
        binding.column = true
      }
      return binding
    },
    borderClass() {
      return this.$vuetify.breakpoint.xsOnly ?  'bottom-border' : 'right-border'
    },
    smAndUp() {
      return this.$vuetify.breakpoint.smAndUp
    },
    thumbnails() {
      return this.images.filter((image) => image.index != 0)
          .sort((a, b) => a.index - b.index)
    }
  },
  data: () => ({
    activeTab: null,
    images: [
      {
        index: 0,
        src: require('@/assets/images/kimchi.jpg?vuetify-preload'),
      },
      {
        index: 1,
        src: require('@/assets/images/kombucha.jpg?vuetify-preload'),
      },
      {
        index: 2,
        src: require('@/assets/images/fermented-gooseberry.jpg?vuetify-preload'),
      }
    ],
    formLink: ' https://docs.google.com/forms/d/e/1FAIpQLSc4bcla8OsmMrxdGdOqIhSRFk3IGeUYzsIgst9NaYFOGMpO_A/viewform',
    img: require('@/assets/images/kimchi.jpg?vuetify-preload'),
    title: 'Cooking Classes',
  }),
  metaInfo() {
    return new MetaInfoBuilder()
      .description('Fermenting vegetables is an old way of preserving them thanks to naturally occurring bacteria.')
      .image(`${window.location.origin}${this.img.src}`)
      .title('The Magic Of Fermentation')
      .build()
  },
  methods: {
    onClick(thumbnail) {
      const current = this.images.find((image) => image.index == 0)

      current.index = thumbnail.index
      thumbnail.index = 0

      this.img = thumbnail.src
    }
  }

}
</script>

<style lang="scss" scoped>
h1 {
  color: #af2f27;
  font-family: 'Nanum Myeongjo', serif !important;
  font-size: 40px !important;
  text-transform: none;
  text-align: center;
}

.flyer {
  margin-bottom: 15px;
}

.underline {
  text-decoration: underline;
}

.terms p {
  font-size: 13px;
  font-style: italic;
}

.pricing-details {
  color: #697b5e;
  border-bottom: 1px solid #697b5e;
  margin-bottom: 23px;
  padding-bottom: 20px;
  text-transform: uppercase;
  font-weight: bold;
}

.v-image {
  margin-top: 14px;
}

strong {
  color: rgb(4,51,255);
  font-size: 25px;
}

.subtext {
  font-style: italic;
}

.you-will {

  .learn,
  .make,
  .keep {
    background: rgba($color: #697b5e, $alpha: 0.8);
    color: white;
    padding-top: 20px;
  }

  h3 {
    text-align: center;
    color: white;
  }

  ul {
    padding: 0;

    li {
      font-size: 15px;
      list-style-type: none;
      padding: 5px 0;
    }
  }

  p {
    padding: 0 20px;
    text-align: center;
  }

  .thumbnails {
    padding: 0 !important;

    .thumbnail {
      cursor: pointer;
      padding: 0 !important;
    }
  }

  .small-print {
    display: block;
    margin-top: 10px;
    font-style: italic;
    font-size: 13px;
  }

  .bottom-border {
    border-bottom: white 1px solid;
  }

  .right-border {
    border-right: white 1px solid;
  }
}

</style>
